import {createRouter} from "@tanstack/react-router";
import {routeTree} from "./routeTree.gen";

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  scrollRestoration: true,
  context: {
    auth: {user: undefined!, profiles: undefined!, isProfilesReady: false},
  },
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
